import { NgModule } from '@angular/core';
import { CoreUiModule } from './core-ui.modules';
import { UiHelpersModule } from './ui-helpers.module';
import { GMBPipe } from '@vfde-fe/ngx-lib/pipes/gmb';
import { CurrencySymbolPipe } from '@vfde-fe/ngx-lib/pipes/currency-symbol';
import { ValidateDatePipe } from '@vfde-fe/ngx-lib/pipes/validate-date';
import { CheckDateDifference } from '@vfde-fe/ngx-lib/pipes/check-date-difference';
import { DotToCommaPipe } from '@vfde-fe/ngx-lib/pipes/dot-to-comma';
import { UnityMediaCustomerNumberPipe } from '@vfde-fe/ngx-lib/pipes/unity-media-customer-number';
import { NgxSmartModalService } from 'ngx-smart-modal';

/** UiWidgetModule */
@NgModule({
    imports: [
        CoreUiModule,
        UiHelpersModule,
    ],
    exports: [
        CoreUiModule,
        UiHelpersModule,
    ],
    providers: [GMBPipe, DotToCommaPipe, CurrencySymbolPipe, ValidateDatePipe, CheckDateDifference, NgxSmartModalService, UnityMediaCustomerNumberPipe],
})
/** uiwidgetModule */
export class UiWidgetModule { }
